var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.jump(_vm.imageValue.jumpPath)}}},[_c('img',{staticClass:"img",style:(_vm.aStyle),attrs:{"src":_vm.imageValue.imagePath || _vm.defaultImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }